import ProductLinkName from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkName.vue";
import ProductLinkDescription from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkDescription.vue";
import ProductLinkClicks from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkClicks.vue";
import ProductLinkBrandName from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkBrandName.vue";
import ProductLinkCoverImage from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkCoverImage.vue";
import ProductLinkViewButton from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkViewButton.vue";
import ProductLinkPrice from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkPrice.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyAffiliateLink extends LegacyEntity {
  get elements() {
    return {
      ProductLinkName,
      ProductLinkDescription,
      ProductLinkClicks,
      ProductLinkBrandName,
      ProductLinkCoverImage,
      ProductLinkViewButton,
      ProductLinkPrice,
    };
  }
}
